import _addClass from './addClass';
export { _addClass as addClass };
import _hasClass from './hasClass';
export { _hasClass as hasClass };
import _removeClass from './removeClass';
export { _removeClass as removeClass };
import _toggleClass from './toggleClass';
export { _toggleClass as toggleClass };